export class GlobalHelper {
    static getRealDomain() {
        return window.location.hostname;
    }
}
